export const WORK_TYPE_MODAL_ID = 'work-type-modal';
